<script setup>
const content = `Bij de verbale test werd u gevraagd om uit zes woorden, precies die twee woorden te kiezen die tezamen met twee aangeboden woorden een analogie vormen. <br> Deze verbaal-analytische capaciteit is van belang voor functies waarvoor verbaal en/of schriftelijk redeneervermogen gevraagd wordt.`
</script>

<template>
  <div class="">
    <InfoTippy :content />
  </div>
</template>
